import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations } from "vuexfire";
import createApp from "@shopify/app-bridge";

import api from "./utils/api";

// import Inbox from "./Inbox/index";
import Integrations from "./Integrations/index";
import Marketing from "./Marketing/index";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    config: {},
    store: {},
    checkouts: {},
    templates: [],
    orderTemplates: [],
    orders: {},
    shopifyPlan: "",
    appBridgeApp: null
  },
  modules: {
    // Inbox,
    Integrations,
    Marketing
  },
  mutations: {
    ...vuexfireMutations,
    SET_CONFIG: (state, payload) => {
      state.config = payload;
    },
    SET_STORE: (state, payload) => {
      state.store = payload;
    },
    SET_SHOPIFY_PLAN: (state, payload) => {
      state.shopifyPlan = payload;
    },
    SET_CHECKOUTS: (state, payload) => {
      state.checkouts = payload;
    },
    SET_ORDERS: (state, payload) => {
      state.orders = payload;
    },
    SET_TEMPLATES: (state, payload) => {
      state.templates = payload;
    },
    SET_ORDER_TEMPLATES: (state, payload) => {
      state.orderTemplates = payload;
    },
    UPDATE_CHECKOUT: (state, payload) => {
      const checkoutIndex = state.checkouts.docs.findIndex(
        checkout => checkout.id === payload.checkoutId
      );
      state.checkouts.docs[checkoutIndex] = {
        ...state.checkouts.docs[checkoutIndex],
        isMessageSent: true
      };
      state.checkouts = { ...state.checkouts };
      //Vue.set(state.checkouts, "docs", state.checkouts.docs);
    },
    UPDATE_ORDER: (state, payload) => {
      const orderIndex = state.orders.docs.findIndex(
        order => order.id === payload.orderId
      );
      state.orders.docs[orderIndex] = {
        ...state.orders.docs[orderIndex],
        isMessageSent: true
      };
      state.orders = { ...state.orders };
      //Vue.set(state.orders, "docs", state.orders.docs);
    },
    UPDATE_TAG: (state, payload) => {
      const checkoutIndex = state.checkouts.docs.findIndex(
        checkout => checkout.id === payload.checkoutId
      );
      const docs = state.checkouts.docs;
      docs[checkoutIndex] = {
        ...docs[checkoutIndex],
        checkoutMeta: { ...payload.customerMeta }
      };

      // Vue.set(state.checkouts, "docs", docs);
      // state.checkouts = { ...state.checkouts, docs };
    },
    updateConfig: (state, payload) => {
      Vue.set(state.config, payload.key, payload.value);
    },
    updateTextsInConfig(state, payload) {
      Vue.set(state.config.texts, payload.key, payload.value);
    },
    SET_APP_BRIDGE_APP(state, payload) {
      state.appBridgeApp = payload;
    }
  },
  getters: {
    getConfig: state => state.config,
    getStore: state => state.store,
    getCheckouts: state => state.checkouts,
    getOrder: state => state.orders,
    getTemplates: state => state.templates,
    getOrderTemplates: state => state.orderTemplates,
    getShopifyPlan: state => state.shopifyPlan,
    getAppBridgeApp: state => state.appBridgeApp
  },
  actions: {
    getConfig(context) {
      return api.get(`shopify/config`).then(response => {
        context.commit("SET_CONFIG", response.config);
        context.commit("SET_STORE", response.store);
        context.commit("SET_SHOPIFY_PLAN", response.shopifyPlan);
        return response;
      });
    },
    updateConfig(context, payload) {
      return api.put(`shopify/config`, payload.requestParams).then(response => {
        context.commit("SET_CONFIG", response.config);
        return response;
      });
    },
    joinWaitList(context, payload) {
      return api
        .put(`shopify/joinwaitlist`, payload.requestParams)
        .then(response => {
          return response;
        });
    },
    getAbadonedCarts(context, payload) {
      return api.get(`checkouts/?page=${payload.page}`).then(response => {
        context.commit("SET_CHECKOUTS", response.checkouts);
      });
    },
    getCheckout(context, payload) {
      return api.get(`checkouts/${payload.checkoutId}`);
    },
    updateCheckout(context, payload) {
      return api
        .put(`checkouts/${payload.checkoutId}`, payload.requestParams)
        .then(() => {
          context.commit("UPDATE_CHECKOUT", payload);
        });
    },
    updateOrder(context, payload) {
      return api
        .put(`order/${payload.orderId}`, payload.requestParams)
        .then(() => {
          context.commit("UPDATE_ORDER", payload);
        });
    },

    updateTag(context, payload) {
      return api
        .put(`checkouts/tag/${payload.checkoutId}`, payload.requestParams)
        .then(() => {
          // context.commit("UPDATE_TAG", {
          //   ...payload,
          //   customerMeta: response.customerMeta
          // });
        });
    },
    updateOrderTag(context, payload) {
      return api
        .put(`order/tag/${payload.orderId}`, payload.requestParams)
        .then(() => {
          // context.commit("UPDATE_TAG", {
          //   ...payload,
          //   customerMeta: response.customerMeta
          // });
        });
    },
    getAnalytics(context, payload) {
      return api.get(
        `report/analytics?startDate=${payload.startDate}&endDate=${payload.endDate}`
      );
    },
    getChatAnalytics() {
      return api.get(`chat/analytics`);
    },

    getOrderList(context, payload) {
      let queryString = `?page=${payload.page}`;
      if (payload.searchText) {
        queryString = `${queryString}&search=${payload.searchText}`;
      }
      return api.get(`order/${queryString}`).then(response => {
        context.commit("SET_ORDERS", response.orders);
      });
    },

    getTemplates(context) {
      return api.get(`template/`).then(response => {
        context.commit("SET_TEMPLATES", response.templates);
      });
    },
    updateTemplate(context, payload) {
      return api.put(`template/${payload.templateId}`, payload.requestParams);
    },
    deleteTemplate(context, payload) {
      return api.delete(`template/${payload.templateId}`);
    },
    createTemplate(context, payload) {
      return api.post(`template/`, payload.requestParams);
    },

    getOrderTemplates(context) {
      return api.get(`ordertemplate/`).then(response => {
        context.commit("SET_ORDER_TEMPLATES", response.templates);
      });
    },
    updateOrderTemplate(context, payload) {
      return api.put(
        `ordertemplate/${payload.templateId}`,
        payload.requestParams
      );
    },
    deleteOrderTemplate(context, payload) {
      return api.delete(`ordertemplate/${payload.templateId}`);
    },
    createOrderTemplate(context, payload) {
      return api.post(`ordertemplate/`, payload.requestParams);
    },
    login(context, payload) {
      return api.get(`shopify/shop/login?shop=${payload.domain}`);
    },
    selectPlan(context, payload) {
      return api.post(`shopify/shop/plan/select`, payload.requestParams);
    },
    getReport(context, payload) {
      return api.get(`report/${payload.reportId}`);
    },
    getChatConfig() {
      return api.get(`chat/`);
    },
    updateChatConfig(context, payload) {
      return api.put(`chat/`, payload.requestParams);
    },
    activateChat() {
      return api.post(`chat/activate`);
    },
    enableCodVerification() {
      return api.post(`chat/cod/activate`);
    },
    deactivateChat() {
      return api.post(`chat/deactivate`);
    },
    activateShare() {
      return api.post(`chat/share/activate`);
    },
    deactivateShare() {
      return api.post(`chat/share/deactivate`);
    },
    getAutomationConfig() {
      return api.get(`automation`);
    },
    updateAutomationConfig(context, payload) {
      return api.put(`automation`, payload.requestParams);
    },
    completedOptinSteps() {
      return api.post(`automation/optincompletion`);
    },
    addWhatsappApiApplication(context, payload) {
      return api.post(`automation/application`, payload.requestParams);
    },
    getWhatsappApiApplication() {
      return api.get(`automation/application`);
    },
    getMessageLog(context, payload) {
      return api.get(`automation/messagelog/?page=${payload.page}`);
    },
    checkUsageLimit() {
      return api.get(`checkouts/checklimit`);
    },
    updateUsageLimit() {
      return api.put(`checkouts/checklimit`);
    },
    getUsers() {
      return api.get(`shopify/shop/users`);
    },
    updateNotification(context, payload) {
      return api.put(`shopify/shop/users`, payload.requestParams);
    },
    enableOrderNotifications() {
      return api.post(`order/enable`);
    },
    getTotalRecoveredValue() {
      return api.get(`checkouts/totalrecovered`);
    },
    getCodOrder(context, payload) {
      return api.get(`order/codorder?shortCode=${payload.shortCode}`);
    },
    updateCodOrder(context, payload) {
      return api.put(
        `order/codorder?shortCode=${payload.shortCode}`,
        payload.requestParams
      );
    },
    updatePreference(context, payload) {
      return api.post(`shopify/updatedesktop`, payload.requestParams);
    },
    updateOnboardingFlag(context, payload) {
      return api
        .post(`shopify/onboardingflags`, payload.requestParams)
        .then(response => {
          context.commit("SET_CONFIG", response.config);
        });
    },
    updateOnboardingCompletion(context) {
      return api.post(`shopify/onboardingcomplete`).then(response => {
        context.commit("SET_CONFIG", response.config);
      });
    },
    getEmbedUrl() {
      return api.get(`chat/embedurl`);
    },
    initAppBridge(context) {
      const host = new URLSearchParams(location.search).get("host");
      if (host) {
        const config = {
          apiKey: process.env.VUE_APP_SHOPIFY_API_KEY,
          host,
          forceRedirect: false
        };
        const app = createApp(config);
        context.commit("SET_APP_BRIDGE_APP", app);
        console.log("app bridge intialized");
      }
    }
  }
});
